export default __webpack_public_path__ + "static/media/user-icon.81d7b418.svg";